var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWorkspaceBigContractingcomponent = function SvgWorkspaceBigContractingcomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 3,
    fill: "#53D1BD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.25 12.25h6a3 3 0 0 1 3 3V22h-1.5v-2.25H9.25V22h-1.5V10.75h1.5v6.75h6v-5.25Zm-.75 2.25a2.247 2.247 0 0 1-2.25 2.25A2.247 2.247 0 0 1 10 14.5a2.247 2.247 0 0 1 2.25-2.25 2.247 2.247 0 0 1 2.25 2.25Z",
    fill: "#fff"
  })));
};
export default SvgWorkspaceBigContractingcomponent;